import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    blkmUrl: process.env.NODE_ENV === 'production'? "https://www.zhendantech.com/baolaikem/":"https://demo.inner.zhendantech.com/baolaikem/",
    blkUrl: process.env.NODE_ENV === 'production'? "https://www.zhendantech.com/pages/blk/":"https://demo.inner.zhendantech.com/pages/blk/",
    bwzUrl: process.env.NODE_ENV === 'production'? "http://www.baowuzhi.cn/":"http://www.baowuzhi.cn/",
    zdUrl: process.env.NODE_ENV === 'production'? "https://www.zhendantech.com": "http://test.zhendantech.com",
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
